import { Mark, Schema } from 'prosemirror-model'

const editorSchema = new Schema({
  nodes: {
    // Single paragraph only — intentionally prevents line breaks
    doc: { content: 'paragraph' },
    paragraph: {
      content: 'inline*',
      group: 'block',
      toDOM: () => ['p', 0] as const,
      parseDOM: [{ tag: 'p' }],
    },
    text: { group: 'inline' },
  },
  marks: {
    link: {
      attrs: { href: { default: '' } },
      inclusive: false,
      parseDOM: [
        {
          tag: 'a[href]',
          getAttrs: (dom: HTMLElement) => ({
            href: dom.getAttribute('href'),
          }),
        },
      ],
      toDOM: (mark: Mark) => {
        const href = /^https?:\/\//i.test(mark.attrs.href)
          ? mark.attrs.href
          : ''
        return [
          'a',
          {
            href,
            class: 'rich-text-editor-link',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
          0,
        ] as const
      },
    },
  },
})

export default editorSchema
